import React, { useState, useEffect } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import LoadingOverlay from '~/components/LoadingOverlay';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from '@material-ui/core';
import Actions_Wind_V2 from '~/Actions_Wind_V2';
import { logError } from '~/common/utils';

const styles = (theme) => ({
    root: {
        margin: theme.spacing(3),
    },
    table: {
        minWidth: 650,
    },
    headerRow: {
        backgroundColor: '#e6f2ff',
    },
    oddRow: {
        backgroundColor: '#ffffff',
    },
    evenRow: {
        backgroundColor: '#f7f7f7',
    },
    link: {
        color: theme.palette.primary.main,
        textDecoration: 'none',
    },
});


const Page_Notification_Admin_Program = ({ classes }) => {
    const [adminPrograms, setAdminPrograms] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        Actions_Wind_V2.getAllUnapprovalAdminPrograms()
            .then((result) => {
                setAdminPrograms(result);
            })
            .catch((error) => {
                logError(error, 'getAllUnapprovalAdminPrograms');
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    return (
        <div className={classes.root}>
            <Typography variant="h5" gutterBottom>
                行政程序 - 文件處理提醒
            </Typography>
            {loading ? (
                <LoadingOverlay loading={loading} />
                // <Typography variant="body1">Loading...</Typography>
            ) : (
                <TableContainer component={Paper}>
                    <Table className={classes.table}>
                        <TableHead>
                            <TableRow className={classes.headerRow}>
                                <TableCell>編號</TableCell>
                                <TableCell>風場</TableCell>
                                <TableCell>程序文件</TableCell>
                                <TableCell>預定申請時間</TableCell>
                                <TableCell>申請狀態</TableCell>
                                <TableCell>簽核狀態</TableCell>
                                <TableCell>相關連結</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {adminPrograms.map((item, index) => (
                                <TableRow
                                    key={item.id}
                                    className={index % 2 === 0 ? classes.evenRow : classes.oddRow}
                                >
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell>{item.windcontract_info.windfield_name}</TableCell>
                                    <TableCell>{item.document_type_name}</TableCell>
                                    <TableCell>{new Date(item.reserve_apply_date).toLocaleDateString()}</TableCell>
                                    <TableCell>{item.apply_status_description}</TableCell>
                                    <TableCell>{item.approval_status_description}</TableCell>
                                    <TableCell>
                                        <a
                                            href={`${item.document_url}?contractId=${item.windcontract_info.windcontract_id}&id=${item.id}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className={classes.link}
                                        >
                                            查看文件
                                        </a>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </div>
    );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

export default compose(connect(mapStateToProps, mapDispatchToProps), withStyles(styles))(Page_Notification_Admin_Program);
